export default __webpack_public_path__ + "static/media/x.e52df9db.svg";